<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif,'PingFang SC','Helvetica Neue','Hiragino Sans GB','Segoe UI','Microsoft YaHei','微软雅黑','sans-serif','Microsoft YaHei';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100%;
  }
  html{
    height: 100%;
    width: 100%;
  }
  body{
    padding: 0;
    margin: 0;
    color: #333;
    min-width: 1000px;
    height: 100%;
    width: 100%;
    overflow-x: auto;
  }
  .el-icon-arrow-down{
    display: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue